/**
 * Mesajul de după o reîncărcare, cerut înainte de ea printr-o cheie din sessionStorage (ex. numele
 * firmei după schimbarea ei). Se arată abia după montarea <Toaster/>: e randat după copii și abia
 * apoi ascultă, iar sonner nu reia mesajele emise înainte. Cheia se șterge abia la închiderea
 * mesajului (`clear`, doar dacă e tot valoarea afișată): dacă pagina pleacă între timp, mesajul
 * apare și pe pagina următoare, iar o montare dublă (StrictMode) nu o consumă fără mesaj. Întoarce
 * oprirea, pentru cleanup-ul efectului.
 *
 * Presupune că <Toaster/> se montează în același commit (nu lazy / dynamic / după un „mounted”).
 * Butoanele `action`/`cancel` din sonner închid mesajul fără onAutoClose/onDismiss: cu ele, cheia ar
 * rămâne și mesajul ar mai apărea o dată la următoarea reîncărcare.
 */
export function showAfterReload(key: string, show: (value: string, clear: () => void) => void): () => void {
  let value: string | null = null;
  try {
    value = sessionStorage.getItem(key);
  } catch {
    return () => {}; // sessionStorage blocat — nimic de afișat
  }
  if (!value) return () => {};
  const found = value;
  const clear = () => {
    // Doar valoarea afișată: între timp poate fi scrisă alta (ex. a doua schimbare de firmă).
    try { if (sessionStorage.getItem(key) === found) sessionStorage.removeItem(key); } catch { /* ignorăm */ }
  };
  const timer = setTimeout(() => show(found, clear), 0);
  return () => clearTimeout(timer);
}
